import { ServiceWorkerSetup } from '../serviceWorker';
export function initTrackers() {
    ServiceWorkerSetup();
}
